import { twMerge } from 'tailwind-merge';
import type { TableRowProps } from '../../TableRow';
import type { ColumnAccessor } from './table-cell-types/column-accessor';
import type { ColumnDefinition } from './table-cell-types/column-definition';

type TableCellProps<Row> = Pick<TableRowProps<Row>, 'cellClassName' | 'row' | 'rowIndex'> & { column: ColumnDefinition<Row> };

export default function TableCell<Row>({ rowIndex, row, column, cellClassName: generalCellClassName }: TableCellProps<Row>) {
  const { accessor, renderCell, cellClassName } = column;
  const className = twMerge('text-center relative p-0', generalCellClassName, cellClassName);
  
  return (
    <td className={className}>
      {renderCell 
        ? renderCell(row, rowIndex) 
        : getCellValue(row, accessor)
    }
    </td>
  );
}

function getCellValue<Row>(row: Row, accessor: ColumnAccessor<Row> | undefined) {
  if (typeof accessor === 'function') {
    return accessor(row);
  }

  if (typeof accessor === 'string') {
    return String(row[accessor]);
  }

  throw new Error('Invalid accessor');
}